export class ValidationUtils {

  static validateRequiredFields = (fields, values) => {
    return fields.reduce((errors, key) => {
      const value = values[key];
      if ((value === undefined || value === "" || value === false)) {
        errors[key] = "Campo requerido";
      }
      return errors;
    }, {});
  }

  static validateDocMultipleUsers = (fields, values) => {
    let docPen;
    let key;
    let i = 0;
    if (Object.keys(values).length > 0) {
      key = Object.keys(values);
      for (i = 0; i < key.length; i++) {
        docPen = fields.filter(field => !field.id.includes(key[i].substr(3)));
      }
    }
    return docPen ? docPen : [];
  }

}
